import SentryLogger from '../helpers/SentryLogger';

/**
 * Redux middleware that reports errors thrown while handling an action.
 * Actions themselves are never logged.
 */
const SentryMiddleware = (store: any) => (next: any) => (action: any) => {
    try {
        return next(action);
    } catch (err) {
        const state = store.getState();

        // Also log to console for development visibility
        console.warn('[ReduxMiddleware]: Error caught', err);
        console.warn('[ReduxMiddleware]: Current state', state);

        SentryLogger.logError('ReduxMiddleware', err as Error, {
            action: {
                type: action.type,
                payload: action.payload
            },
            stateKeys: Object.keys(state) // Don't log full state, just keys
        });

        // Re-throw to maintain error propagation
        throw err;
    }
};

export default SentryMiddleware;
